// icon
import { IconStarFilled } from "@tabler/icons-react";
// link
import { Link } from "react-router";
// splitnumber
import { splitNumber } from "../../features/splitNumber/splitNumber";
// heart
import Heart from "../heart/heart";

const NewProducts = (props: any) => {
    return (
        <>
            <div data-aos="fade-right"
                className="card new-product-card border-0">
                <div className="card-image rounded rounded-4 p-3">
                    <span style={{ zIndex: '99999999' }} className="badge bg-white text-dark icon">جدید</span>
                    <div className="d-flex justify-content-center align-items-center">
                        <Link to={`/products/detail/${props.slug}`} className="text-decoration-none">
                            <img src={props.primary_image} alt="product" />
                        </Link>
                    </div>
                    <div className="icon like-place shadow">
                        <Heart id={props.id} />
                    </div>
                </div>
                <div className="card-body">
                    <Link to={`/products/detail/${props.slug}`} className="text-decoration-none">
                        <div className="d-flex w-100 justify-content-between align-items-center" style={{ height: '45px' }}>
                            <span className="text-dark text-line font-medium-lg mb-0">
                                {props.name}
                            </span>
                        </div>
                        <div className="text-center mt-2">
                            {props?.has_variation !== 0 ? (
                                <>
                                    {props.quantity_check?.price ? (
                                        <span className="card-title price font-medium-lg fw-bold mt-3">{splitNumber(props.quantity_check?.price)}  تومان</span>
                                    ) : (
                                        <span className="card-title text-danger fw-bold price font-medium-lg mt-3">نا موجود</span>
                                    )}
                                </>
                            )
                                :
                                (
                                    <>
                                        {props.count !== 0 ? (
                                            <span className="card-title price fw-bold font-medium-lg mt-3">{splitNumber(props.price)}  تومان</span>
                                        ) : (
                                            <span className="card-title text-danger fw-bold price font-medium-lg mt-3">نا موجود</span>
                                        )}
                                    </>
                                )
                            }
                        </div>
                        <hr style={{ marginTop: '5px' }} />
                        <div className="d-flex align-items-center justify-content-between">
                            <Link to={`/products/detail/${props.slug}`} className="btn btn-primary py-1">
                                خرید
                            </Link>
                            <div className="rate align-middle">
                                <IconStarFilled className="text-warning align-middle me-1" size={14} />
                                <span className="font-medium align-middle mt-2 text-black fw-bold">
                                    {props.rate}
                                </span>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </>
    )
}

export default NewProducts;